module.exports = __webpack_public_path__ + "static/media/sselogo1(nobackwhite).97accc10.png";